import { render, staticRenderFns } from "./EmailTemplate.vue?vue&type=template&id=663cd2b5&"
import script from "./EmailTemplate.vue?vue&type=script&lang=js&"
export * from "./EmailTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\wamp\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('663cd2b5')) {
      api.createRecord('663cd2b5', component.options)
    } else {
      api.reload('663cd2b5', component.options)
    }
    module.hot.accept("./EmailTemplate.vue?vue&type=template&id=663cd2b5&", function () {
      api.rerender('663cd2b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/settings/EmailTemplate.vue"
export default component.exports